



















































import { Vue, Component, Prop } from 'vue-property-decorator'
import FormField from '@/components/reusable-components/form/FormField.vue'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import BaseForm from '@/components/reusable-components/form/BaseForm.vue'
import { ButtonType, ButtonTheme } from '@/utils/ButtonAttr'
import ModalName from '@/utils/ModalName'
import BaseTitle from '@/components/reusable-components/typography/BaseTitle.vue'
import TranslationModule from '../../utils/TranslationModule'
import API from '@/services/API'
// import API from '@/services/API'

@Component({
    name: 'ModalContactUs',
    components: { BaseTitle, BaseForm, BaseButton, FormField },
})
export default class ModalContactUs extends Vue {
    @Prop({ type: String, default: ModalName.MODAL_CONTACT_US }) name!: string
    ButtonType = ButtonType
    ButtonTheme = ButtonTheme
    TranslationModule = TranslationModule
    subject = ''
    message = ''
    loadingSend = false
    hasSent = false

    get isFormReady() {
        return !!(this.subject && this.message)
    }

    async onSendForm() {
        try {
            this.loadingSend = true
            await API.contactFrenchFounders(this.subject, this.message)
            this.hasSent = true
        } catch (e) {
            this.$notify({
                title: '',
            })
            console.error(e)
        } finally {
            this.loadingSend = false
        }
    }
}
